// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__gVeL6","item":"PaymentsMobile_item__5LKeK","label":"PaymentsMobile_label__128Px","amount":"PaymentsMobile_amount__2I8xw"};